// extracted by mini-css-extract-plugin
export default {"customerTable":"vXPRrch1Yp0ekhNauTE9"};